var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length)?_c('div',{staticClass:"errors-box"},[(_vm.guide)?_c('i',{staticClass:"el-icon-warning"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.guide)+"\n  "),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_vm._v("\n      "+_vm._s(error)+"\n    ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }